// for vendor-prefixed properties
const doc = document as any;

export const isFullscreen = () => {
  return (
    doc.fullscreenElement ||
    doc.mozFullScreenElement ||
    doc.webkitFullscreenElement ||
    doc.msFullscreenElement
  );
}

export const toggleFullscreen = () => {

  // for vendor-prefixed properties
  const docEl = document.documentElement as any;

  if (isFullscreen()) {
    // Exit fullscreen
    const exitFullScreen =
      doc.exitFullscreen ||
      doc.webkitExitFullscreen ||
      doc.mozCancelFullScreen ||
      doc.msExitFullscreen;
    if (exitFullScreen) {
      exitFullScreen.call(doc);
    }
  } else {
    // Request fullscreen
    const requestFullScreen =
      docEl.requestFullscreen ||
      docEl.webkitRequestFullscreen ||
      docEl.mozRequestFullScreen ||
      docEl.msRequestFullscreen;
    if (requestFullScreen) {
      requestFullScreen.call(docEl);
    }
  }
}